
import './App.css';
import Main from './Component/Main/Main';

function App() {
  return (
    <div className="App">
      
      <h1 className='app-class'>Welcome to EU Teacher's Profile</h1>
      <Main></Main>

      <footer className='footer-class'>
        <h5>Copyright &copy; 2022 EU Teacher's profile <br></br>
            All rights reserved by <a href="https://www.linkedin.com/in/aurnub-das-272337197/">Aurnab Das</a>
            </h5>
      </footer>
    </div>
  );
}

export default App;
